/* tslint:disable */
/* eslint-disable */
/**
 * Client Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ServiceContactWithDetails } from './ServiceContactWithDetails';
import {
	ServiceContactWithDetailsFromJSON,
	ServiceContactWithDetailsFromJSONTyped,
	ServiceContactWithDetailsToJSON,
} from './ServiceContactWithDetails';

/**
 *
 * @export
 * @interface ServiceContactResponse
 */
export interface ServiceContactResponse {
	/**
	 *
	 * @type {ServiceContactWithDetails}
	 * @memberof ServiceContactResponse
	 */
	serviceContact?: ServiceContactWithDetails;
}

/**
 * Check if a given object implements the ServiceContactResponse interface.
 */
export function instanceOfServiceContactResponse(value: object): boolean {
	let isInstance = true;

	return isInstance;
}

export function ServiceContactResponseFromJSON(json: any): ServiceContactResponse {
	return ServiceContactResponseFromJSONTyped(json, false);
}

export function ServiceContactResponseFromJSONTyped(
	json: any,
	ignoreDiscriminator: boolean
): ServiceContactResponse {
	if (json === undefined || json === null) {
		return json;
	}
	return {
		serviceContact: !exists(json, 'serviceContact')
			? undefined
			: ServiceContactWithDetailsFromJSON(json['serviceContact']),
	};
}

export function ServiceContactResponseToJSON(value?: ServiceContactResponse | null): any {
	if (value === undefined) {
		return undefined;
	}
	if (value === null) {
		return null;
	}
	return {
		serviceContact: ServiceContactWithDetailsToJSON(value.serviceContact),
	};
}
